var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-message-container",class:_vm.color,style:(_vm.style())},[(_vm.showIcon)?_c('font-awesome-icon',{staticClass:"icon-container",attrs:{"icon":"fa-triangle-exclamation"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }